import { PropsWithChildren } from 'react';

import { useHighlightFocus } from '@/utils/hooks';
import '@/styles/styles.scss';

export const RegPlatformStyles = ({ children }: PropsWithChildren) => {
  useHighlightFocus();
  return <>{children}</>;
};
